/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SettingManagementCreateSettingRequest } from '../models/SettingManagementCreateSettingRequest';
import type { SettingManagementCreateSettingResponseApiRespoonse } from '../models/SettingManagementCreateSettingResponseApiRespoonse';
import type { SettingManagementDeleteSettingRequest } from '../models/SettingManagementDeleteSettingRequest';
import type { SettingManagementDeleteSettingResponseApiRespoonse } from '../models/SettingManagementDeleteSettingResponseApiRespoonse';
import type { SettingManagementEditSettingRequest } from '../models/SettingManagementEditSettingRequest';
import type { SettingManagementEditSettingResponseApiRespoonse } from '../models/SettingManagementEditSettingResponseApiRespoonse';
import type { SettingManagementListSettingRequest } from '../models/SettingManagementListSettingRequest';
import type { SettingManagementListSettingResponseApiRespoonse } from '../models/SettingManagementListSettingResponseApiRespoonse';
import type { SettingManagementViewSettingRequest } from '../models/SettingManagementViewSettingRequest';
import type { SettingManagementViewSettingResponseApiRespoonse } from '../models/SettingManagementViewSettingResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SettingManagementSettingService {

    /**
     * 辞書一覧 / 辞書検索
     * @param requestBody
     * @returns SettingManagementListSettingResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSetting(
        requestBody: SettingManagementListSettingRequest,
    ): CancelablePromise<SettingManagementListSettingResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/setting',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 辞書の新規登録
     * @param requestBody
     * @returns SettingManagementCreateSettingResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSettingCreate(
        requestBody: SettingManagementCreateSettingRequest,
    ): CancelablePromise<SettingManagementCreateSettingResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/setting/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * View Setting
     * @param requestBody
     * @returns SettingManagementViewSettingResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSettingView(
        requestBody: SettingManagementViewSettingRequest,
    ): CancelablePromise<SettingManagementViewSettingResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/setting/view',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 辞書の更新
     * @param requestBody
     * @returns SettingManagementEditSettingResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSettingEdit(
        requestBody: SettingManagementEditSettingRequest,
    ): CancelablePromise<SettingManagementEditSettingResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/setting/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 辞書の削除
     * @param requestBody
     * @returns SettingManagementDeleteSettingResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSettingDelete(
        requestBody: SettingManagementDeleteSettingRequest,
    ): CancelablePromise<SettingManagementDeleteSettingResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/setting/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
